import { PagesList } from '../components/List/PagesList';
import { UrlPlatform } from '../types';

import { useDepartmentStore } from '@/stores/department';
import { convertToCamelCase } from '@/utils';

type Props = {
  platform: UrlPlatform;
};

export const Pages = ({ platform }: Props) => {
  const department = useDepartmentStore((state) => state.selected);

  return <PagesList platform={convertToCamelCase(platform)} department={department} />;
};
